export default JSON.stringify({
  refreshToken: 'fsfdsgsf',
  message: 'success',
})
